/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import AppWrapper from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { swReadyService, offlineAssetWarmer, checkVersionMismatch } from './utils/services';

// Catch ad-hoc `import axios from 'axios'` call sites (Header status polling,
// ManageAssignments exports, AddExistingRetailerModal, etc.) — those bypass
// _API in lib/httpClient.js but still hit our BE and carry the version
// header. Pass-through: read the version header, return the response untouched.
axios.interceptors.response.use((response) => {
  checkVersionMismatch(response);
  return response;
});

const { REACT_APP_SENTRY_DSN, REACT_APP_SENTRY_ENV } = process.env;
if (REACT_APP_SENTRY_DSN !== 'null') {
  Sentry.init({
    dsn: REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    environment: REACT_APP_SENTRY_ENV,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
  document.getElementById('root'),
);

serviceWorkerRegistration.register({
  onSuccess: () => swReadyService.setReady(true),
  onUpdate: () => swReadyService.setReady(true),
});

// Ask the SW to warm the critical offline icons on every boot. The handler
// skips URLs that are already cached, so this is essentially free when the
// cache is populated and self-healing if entries were evicted between
// sessions. Fire-and-forget — it must never block app startup.
offlineAssetWarmer.warmOfflineAssets();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
